import {connect} from 'react-redux';
import EditMetaDataItem from './EditMetaDataItem';
import {deleteFile} from '../../../../modules/Inspection/actions/files/deleteFile';
import {updateFileMetadata} from '../../../../modules/Inspection/actions/files/updateFileMetadata';
import {getFileList} from '../../../../modules/Inspection/actions/files/getFileList';
import {getFile} from '../../../../modules/Inspection/actions/files/getFile';
import {showGlobalErrorMessage} from '../../../actions/globalErrorMessage/showGlobalErrorMessage';
import {getShumaStepStatus} from "../../../../modules/Inspection/actions/steps/getShumaStepStatus";
import {editPDFPages} from '../../../../modules/Inspection/actions/files/editPDFPages';

export default connect(
  null,
  {
    deleteFile,
    updateFileMetadata,
    getFileList,
    getFile,
    showGlobalErrorMessage,
    getShumaStepStatus,
    editPDFPages
  }
)(EditMetaDataItem);
